import { h } from "preact";
import { useSelector, useDispatch } from "react-redux";
import uniq from "lodash/uniq";

import { setTaskProgressFilter } from "../store/uiSlice";
import Filter from "./Filter.jsx";
import { taskState } from "../helpers";

const OPTIONS = [
  { value: "", text: "All tasks" },
  { value: "blocked", text: "Blocked tasks" },
  { value: "done", text: "Done tasks" },
  { value: "in progress", text: "In progress tasks" },
  { value: "ready", text: "Ready tasks" },
];

export default function TaskProgressFilter() {
  const dispatch = useDispatch();
  const selected = useSelector((state) => state.ui.taskProgressFilter);
  const tasks = useSelector((state) => state.tasks.items);
  const taskStates = uniq(tasks.map((task) => taskState(task)));
  const options = OPTIONS.filter(
    (option) => taskStates.includes(option.value) || option.value === ""
  );

  function handleChange(value) {
    dispatch(setTaskProgressFilter(value));
  }
  if (taskStates.length === 1) {
    return null;
  }

  return (
    <Filter
      icon="check_circle"
      onChange={handleChange}
      options={options}
      selected={selected}
      dataQa="task-progress-filter"
    />
  );
}
